import { TextBoxLayoutStyle, ZipCodeBox } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const ZipCodeField = () => {
    const value = useWizardDemoStore((state) => state.property.zip);
    const updateProperty = useWizardDemoStore((state) => state.updateProperty);

    return (
        <ZipCodeBox
            id='propertyZipCode'
            value={value}
            onChange={(zip) => updateProperty({ zip })}
            label='Zip Code'
            required={true}
            width={'auto'}
            placeholder='Zip code, 5 digit'
            layoutStyle={TextBoxLayoutStyle.Horizontal}
            height='36px'
        />
    );
};
